import { useContext, useEffect, useState } from "react";
import { getFirmwareUpdateProgress } from "src/services/alen/firmwareUpdate";
import { AuthContext } from "src/contexts/AuthContext";
import { AlenFirmwareUpdateStatus } from "./types";

const useFirmwareUpdateProgress = (deviceId: string, channel: number) => {
  const [status, setStatus] = useState<AlenFirmwareUpdateStatus>(
    AlenFirmwareUpdateStatus.UpdateInProgress
  );
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const alenToken = user?.alen;
    if (!alenToken) return () => {};
    const interval = setInterval(() => {
      getFirmwareUpdateProgress(alenToken, deviceId, channel).then((res) => {
        const progress = res.result;
        setStatus(progress.upgrade_status);
        if (
          progress.upgrade_status !== AlenFirmwareUpdateStatus.UpdateInProgress
        ) {
          clearInterval(interval);
        }
      });
    }, 5000);
    return () => {
      clearInterval(interval);
    };
  }, [user, channel, deviceId]);

  return status;
};

export default useFirmwareUpdateProgress;
